/* tslint:disable */
/* eslint-disable */
/**
 * ciselniky Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CiselnikPolozka
 */
export interface CiselnikPolozka {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'nazov': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozka
     */
    'uroven'?: number;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'prefix'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'legislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'platny': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'existujeFormular'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'generovanySystemom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'povolitZadavanieFormularom'?: boolean;
}
/**
 * 
 * @export
 * @interface CiselnikPolozkaNode
 */
export interface CiselnikPolozkaNode {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozkaNode
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozkaNode
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozkaNode
     */
    'kod': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozkaNode
     */
    'uroven'?: number;
    /**
     * 
     * @type {Array<CiselnikPolozkaNode>}
     * @memberof CiselnikPolozkaNode
     */
    'polozky'?: Array<CiselnikPolozkaNode>;
}
/**
 * 
 * @export
 * @interface CiselnikPolozkaTree
 */
export interface CiselnikPolozkaTree {
    /**
     * 
     * @type {Array<CiselnikPolozkaNode>}
     * @memberof CiselnikPolozkaTree
     */
    'rootList': Array<CiselnikPolozkaNode>;
}
/**
 * 
 * @export
 * @interface Kontakt
 */
export interface Kontakt {
    /**
     * 
     * @type {string}
     * @memberof Kontakt
     */
    'telefon'?: string;
    /**
     * 
     * @type {string}
     * @memberof Kontakt
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Kontakt
     */
    'adresa'?: string;
}
/**
 * 
 * @export
 * @interface LdapPouzivatelItem
 */
export interface LdapPouzivatelItem {
    /**
     * 
     * @type {string}
     * @memberof LdapPouzivatelItem
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LdapPouzivatelItem
     */
    'nazov'?: string;
}
/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'ldapUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'nazovVGenitive'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'identifikator'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uplnyNazov'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Organizacia
     */
    'legislativna'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Organizacia
     */
    'technicka'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Organizacia
     */
    'verejna'?: boolean;
    /**
     * 
     * @type {Kontakt}
     * @memberof Organizacia
     */
    'kontakt'?: Kontakt;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizacnaSkupinaEnum = {
    Pripomienkovatel: 'PRIPOMIENKOVATEL',
    PripomienkovatelPoslaneckyNavrhZakona: 'PRIPOMIENKOVATEL_POSLANECKY_NAVRH_ZAKONA',
    Pov: 'POV',
    Vestnik: 'VESTNIK',
    SpravcaAktuEu: 'SPRAVCA_AKTU_EU',
    Gestor: 'GESTOR',
    NotifikovatAktyEu: 'NOTIFIKOVAT_AKTY_EU',
    SchvalovatelGestora: 'SCHVALOVATEL_GESTORA',
    NotifikovatPredsedaVlady: 'NOTIFIKOVAT_PREDSEDA_VLADY'
} as const;

export type OrganizacnaSkupinaEnum = typeof OrganizacnaSkupinaEnum[keyof typeof OrganizacnaSkupinaEnum];


/**
 * 
 * @export
 * @interface Stadium
 */
export interface Stadium {
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof Stadium
     */
    'hodnota': StadiumMaterialuEnum;
    /**
     * 
     * @type {string}
     * @memberof Stadium
     */
    'nazov': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumMaterialuEnum = {
    FinalnePredbezneStanovisko: 'FINALNE_PREDBEZNE_STANOVISKO',
    Mpk: 'MPK',
    PredVyhlasenimVZbierke: 'PRED_VYHLASENIM_V_ZBIERKE',
    PredpripravnaFazaUkoncena: 'PREDPRIPRAVNA_FAZA_UKONCENA',
    PripravaMaterialu: 'PRIPRAVA_MATERIALU',
    PriradenieGestora: 'PRIRADENIE_GESTORA',
    ProcesUkonceny: 'PROCES_UKONCENY',
    RokovanieNrsr: 'ROKOVANIE_NRSR',
    RokovaniePov: 'ROKOVANIE_POV',
    RokovanieVlada: 'ROKOVANIE_VLADA',
    SchvalenieGestora: 'SCHVALENIE_GESTORA',
    SchvalovanieMinister: 'SCHVALOVANIE_MINISTER',
    SpracovaniePredkladatel: 'SPRACOVANIE_PREDKLADATEL',
    VyhlaseneVZbierke: 'VYHLASENE_V_ZBIERKE',
    VyhodnotenieMpk: 'VYHODNOTENIE_MPK',
    VyhodnotenieMpkAkty: 'VYHODNOTENIE_MPK_AKTY',
    Vyjadrenia: 'VYJADRENIA',
    ZapisStanoviska: 'ZAPIS_STANOVISKA',
    ZapisPredbeznehoStanoviska: 'ZAPIS_PREDBEZNEHO_STANOVISKA',
    ZapisDoplnenehoPredbeznehoStanoviska: 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
    AdministraciaProcesu: 'ADMINISTRACIA_PROCESU',
    AproximaciaNariadenia: 'APROXIMACIA_NARIADENIA',
    AproximaciaSmernice: 'APROXIMACIA_SMERNICE',
    ArchivovanyAeu: 'ARCHIVOVANY_AEU',
    CakajuciPubMod: 'CAKAJUCI_PUB_MOD',
    DoplneniePozicie: 'DOPLNENIE_POZICIE',
    FinalizaciaInstrukcie: 'FINALIZACIA_INSTRUKCIE',
    FinalizaciaNotifikacnychFormularov: 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
    FinalizaciaPozicie: 'FINALIZACIA_POZICIE',
    KontrolaRedakcUprav: 'KONTROLA_REDAKC_UPRAV',
    MzvEz: 'MZV_EZ',
    NotifikacnyFormular: 'NOTIFIKACNY_FORMULAR',
    OdoslaneRokovanieNrsr: 'ODOSLANE_ROKOVANIE_NRSR',
    OdoslaneRokovanieVlady: 'ODOSLANE_ROKOVANIE_VLADY',
    OdoslaneZz: 'ODOSLANE_ZZ',
    PredPublikovanim: 'PRED_PUBLIKOVANIM',
    PriebezneZapracovaniePrip: 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
    PripomienkovaniePozmenNavrhovNrsr: 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
    PripravaMaterialuAdmin: 'PRIPRAVA_MATERIALU_ADMIN',
    PripravaMaterialuPi: 'PRIPRAVA_MATERIALU_PI',
    PripravaNelegMaterialu: 'PRIPRAVA_NELEG_MATERIALU',
    PriradenieGestoraCoreper: 'PRIRADENIE_GESTORA_COREPER',
    PriradenieGestoraNariadenie: 'PRIRADENIE_GESTORA_NARIADENIE',
    PriradenieGestoraRadaEu: 'PRIRADENIE_GESTORA_RADA_EU',
    PriradenieGestoraSmernica: 'PRIRADENIE_GESTORA_SMERNICA',
    PublikaciaRo: 'PUBLIKACIA_RO',
    RokovanieLrv: 'ROKOVANIE_LRV',
    RokovanieNrsrNelegMat: 'ROKOVANIE_NRSR_NELEG_MAT',
    RokovaniePracKomisii: 'ROKOVANIE_PRAC_KOMISII',
    RokovaniePredkladatel: 'ROKOVANIE_PREDKLADATEL',
    RokovaniePredkladatelNelegMat: 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
    RokovanieVladaNelegMat: 'ROKOVANIE_VLADA_NELEG_MAT',
    SefredaktorPridelovanie: 'SEFREDAKTOR_PRIDELOVANIE',
    SefredaktorSchvaleniePredPubmod: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
    SefredaktorSchvaleniePredPubmodNelegMat: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
    SchvaleneNaVlade: 'SCHVALENE_NA_VLADE',
    SchvalovaniePrezident: 'SCHVALOVANIE_PREZIDENT',
    SpracovanieRedaktor: 'SPRACOVANIE_REDAKTOR',
    SpracovanieRedaktorNelegMat: 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
    SpracovanieSefredaktor: 'SPRACOVANIE_SEFREDAKTOR',
    SpracovanieSefredaktorNelegMat: 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
    VyhodnotenieMpkNelegMat: 'VYHODNOTENIE_MPK_NELEG_MAT',
    VyhodnotenieRokovaniaNrsr: 'VYHODNOTENIE_ROKOVANIA_NRSR',
    VyhodnotenieVysledkuRokovania: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
    VyhodnotenieVysledkuRokovaniaNelegMat: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
    VytvorenieCiastkovejInstrukcie: 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
    VytvoreniePozicie: 'VYTVORENIE_POZICIE',
    ZaevidovanieMaterialu: 'ZAEVIDOVANIE_MATERIALU',
    ZaevidovanieOpatrenia: 'ZAEVIDOVANIE_OPATRENIA'
} as const;

export type StadiumMaterialuEnum = typeof StadiumMaterialuEnum[keyof typeof StadiumMaterialuEnum];


/**
 * 
 * @export
 * @interface Sviatok
 */
export interface Sviatok {
    /**
     * 
     * @type {string}
     * @memberof Sviatok
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Sviatok
     */
    'datum'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TypCiselnikaEnum = {
    LegislativnaOblast: 'LEGISLATIVNA_OBLAST',
    Jazyk: 'JAZYK',
    TypAktEu: 'TYP_AKT_EU',
    Institucia: 'INSTITUCIA',
    TypMaterialu: 'TYP_MATERIALU',
    StupenUtajenia: 'STUPEN_UTAJENIA',
    UzemnaPlatnost: 'UZEMNA_PLATNOST',
    TypDokumentuAktEu: 'TYP_DOKUMENTU_AKT_EU',
    TypSprievodnehoDokumentu: 'TYP_SPRIEVODNEHO_DOKUMENTU',
    ClanokDohovoruEsLp: 'CLANOK_DOHOVORU_ES_LP',
    TypJudikatuEsLp: 'TYP_JUDIKATU_ES_LP'
} as const;

export type TypCiselnikaEnum = typeof TypCiselnikaEnum[keyof typeof TypCiselnikaEnum];



/**
 * CiselnikPolozkaExternalApi - axios parameter creator
 * @export
 */
export const CiselnikPolozkaExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get ciselnik polozky.
         * @param {Array<string>} [ids] One or more ids.
         * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
         * @param {boolean} [valid] valid for ciselnik polozka.
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCiselnikPolozka: async (ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/polozky-ciselnika`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (typy) {
                localVarQueryParameter['typy'] = typy.join(COLLECTION_FORMATS.csv);
            }

            if (valid !== undefined) {
                localVarQueryParameter['valid'] = valid;
            }

            if (hladanyNazov !== undefined) {
                localVarQueryParameter['hladanyNazov'] = hladanyNazov;
            }

            if (kody) {
                localVarQueryParameter['kody'] = kody.join(COLLECTION_FORMATS.csv);
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CiselnikPolozkaExternalApi - functional programming interface
 * @export
 */
export const CiselnikPolozkaExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CiselnikPolozkaExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get ciselnik polozky.
         * @param {Array<string>} [ids] One or more ids.
         * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
         * @param {boolean} [valid] valid for ciselnik polozka.
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCiselnikPolozka(ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CiselnikPolozka>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCiselnikPolozka(ids, typy, valid, hladanyNazov, kody, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CiselnikPolozkaExternalApi.getCiselnikPolozka']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CiselnikPolozkaExternalApi - factory interface
 * @export
 */
export const CiselnikPolozkaExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CiselnikPolozkaExternalApiFp(configuration)
    return {
        /**
         * Get ciselnik polozky.
         * @param {Array<string>} [ids] One or more ids.
         * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
         * @param {boolean} [valid] valid for ciselnik polozka.
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCiselnikPolozka(ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CiselnikPolozka>> {
            return localVarFp.getCiselnikPolozka(ids, typy, valid, hladanyNazov, kody, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CiselnikPolozkaExternalApi - object-oriented interface
 * @export
 * @class CiselnikPolozkaExternalApi
 * @extends {BaseAPI}
 */
export class CiselnikPolozkaExternalApi extends BaseAPI {
    /**
     * Get ciselnik polozky.
     * @param {Array<string>} [ids] One or more ids.
     * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
     * @param {boolean} [valid] valid for ciselnik polozka.
     * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
     * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CiselnikPolozkaExternalApi
     */
    public getCiselnikPolozka(ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options?: RawAxiosRequestConfig) {
        return CiselnikPolozkaExternalApiFp(this.configuration).getCiselnikPolozka(ids, typy, valid, hladanyNazov, kody, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HierarchickyCiselnikTreeExternalApi - axios parameter creator
 * @export
 */
export const HierarchickyCiselnikTreeExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get tree of hierarchicky ciselnik.
         * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHierarchickyCiselnikTree: async (typ?: TypCiselnikaEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ciselnik-polozky/hierarchicky`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HierarchickyCiselnikTreeExternalApi - functional programming interface
 * @export
 */
export const HierarchickyCiselnikTreeExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HierarchickyCiselnikTreeExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get tree of hierarchicky ciselnik.
         * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHierarchickyCiselnikTree(typ?: TypCiselnikaEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CiselnikPolozkaTree>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHierarchickyCiselnikTree(typ, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchickyCiselnikTreeExternalApi.getHierarchickyCiselnikTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HierarchickyCiselnikTreeExternalApi - factory interface
 * @export
 */
export const HierarchickyCiselnikTreeExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HierarchickyCiselnikTreeExternalApiFp(configuration)
    return {
        /**
         * Get tree of hierarchicky ciselnik.
         * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHierarchickyCiselnikTree(typ?: TypCiselnikaEnum, options?: RawAxiosRequestConfig): AxiosPromise<CiselnikPolozkaTree> {
            return localVarFp.getHierarchickyCiselnikTree(typ, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HierarchickyCiselnikTreeExternalApi - object-oriented interface
 * @export
 * @class HierarchickyCiselnikTreeExternalApi
 * @extends {BaseAPI}
 */
export class HierarchickyCiselnikTreeExternalApi extends BaseAPI {
    /**
     * Get tree of hierarchicky ciselnik.
     * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchickyCiselnikTreeExternalApi
     */
    public getHierarchickyCiselnikTree(typ?: TypCiselnikaEnum, options?: RawAxiosRequestConfig) {
        return HierarchickyCiselnikTreeExternalApiFp(this.configuration).getHierarchickyCiselnikTree(typ, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizaciaLdapPouzivateliaMapExternalApi - axios parameter creator
 * @export
 */
export const OrganizaciaLdapPouzivateliaMapExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Map of ldap pouzivatel list in ldap organizacia
         * @param {Array<string>} [ids] List of ids for organizacia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelMapByOrgUuids: async (ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizacie/ldap/pouzivatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizaciaLdapPouzivateliaMapExternalApi - functional programming interface
 * @export
 */
export const OrganizaciaLdapPouzivateliaMapExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizaciaLdapPouzivateliaMapExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Map of ldap pouzivatel list in ldap organizacia
         * @param {Array<string>} [ids] List of ids for organizacia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatelMapByOrgUuids(ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<LdapPouzivatelItem>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatelMapByOrgUuids(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizaciaLdapPouzivateliaMapExternalApi.getPouzivatelMapByOrgUuids']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizaciaLdapPouzivateliaMapExternalApi - factory interface
 * @export
 */
export const OrganizaciaLdapPouzivateliaMapExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizaciaLdapPouzivateliaMapExternalApiFp(configuration)
    return {
        /**
         * Map of ldap pouzivatel list in ldap organizacia
         * @param {Array<string>} [ids] List of ids for organizacia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelMapByOrgUuids(ids?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<LdapPouzivatelItem>; }> {
            return localVarFp.getPouzivatelMapByOrgUuids(ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizaciaLdapPouzivateliaMapExternalApi - object-oriented interface
 * @export
 * @class OrganizaciaLdapPouzivateliaMapExternalApi
 * @extends {BaseAPI}
 */
export class OrganizaciaLdapPouzivateliaMapExternalApi extends BaseAPI {
    /**
     * Map of ldap pouzivatel list in ldap organizacia
     * @param {Array<string>} [ids] List of ids for organizacia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizaciaLdapPouzivateliaMapExternalApi
     */
    public getPouzivatelMapByOrgUuids(ids?: Array<string>, options?: RawAxiosRequestConfig) {
        return OrganizaciaLdapPouzivateliaMapExternalApiFp(this.configuration).getPouzivatelMapByOrgUuids(ids, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizaciaListExternalApi - axios parameter creator
 * @export
 */
export const OrganizaciaListExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of organizacia
         * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
         * @param {Array<string>} [ids] List of ids for organizacna skupina
         * @param {boolean} [ldap] Filter by ldap attribute
         * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
         * @param {boolean} [legislativna] Filter by legislativna attribute
         * @param {boolean} [platna] Filter by platna attribute
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizaciaList: async (typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, platna?: boolean, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizacie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typOrganizacnejSkupiny !== undefined) {
                localVarQueryParameter['typOrganizacnejSkupiny'] = typOrganizacnejSkupiny;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (ldap !== undefined) {
                localVarQueryParameter['ldap'] = ldap;
            }

            if (nazov !== undefined) {
                localVarQueryParameter['nazov'] = nazov;
            }

            if (legislativna !== undefined) {
                localVarQueryParameter['legislativna'] = legislativna;
            }

            if (platna !== undefined) {
                localVarQueryParameter['platna'] = platna;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizaciaListExternalApi - functional programming interface
 * @export
 */
export const OrganizaciaListExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizaciaListExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * List of organizacia
         * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
         * @param {Array<string>} [ids] List of ids for organizacna skupina
         * @param {boolean} [ldap] Filter by ldap attribute
         * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
         * @param {boolean} [legislativna] Filter by legislativna attribute
         * @param {boolean} [platna] Filter by platna attribute
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizaciaList(typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, platna?: boolean, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Organizacia>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizaciaList(typOrganizacnejSkupiny, ids, ldap, nazov, legislativna, platna, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizaciaListExternalApi.getOrganizaciaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizaciaListExternalApi - factory interface
 * @export
 */
export const OrganizaciaListExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizaciaListExternalApiFp(configuration)
    return {
        /**
         * List of organizacia
         * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
         * @param {Array<string>} [ids] List of ids for organizacna skupina
         * @param {boolean} [ldap] Filter by ldap attribute
         * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
         * @param {boolean} [legislativna] Filter by legislativna attribute
         * @param {boolean} [platna] Filter by platna attribute
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizaciaList(typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, platna?: boolean, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Organizacia>> {
            return localVarFp.getOrganizaciaList(typOrganizacnejSkupiny, ids, ldap, nazov, legislativna, platna, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizaciaListExternalApi - object-oriented interface
 * @export
 * @class OrganizaciaListExternalApi
 * @extends {BaseAPI}
 */
export class OrganizaciaListExternalApi extends BaseAPI {
    /**
     * List of organizacia
     * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
     * @param {Array<string>} [ids] List of ids for organizacna skupina
     * @param {boolean} [ldap] Filter by ldap attribute
     * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
     * @param {boolean} [legislativna] Filter by legislativna attribute
     * @param {boolean} [platna] Filter by platna attribute
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizaciaListExternalApi
     */
    public getOrganizaciaList(typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, platna?: boolean, limit?: number, options?: RawAxiosRequestConfig) {
        return OrganizaciaListExternalApiFp(this.configuration).getOrganizaciaList(typOrganizacnejSkupiny, ids, ldap, nazov, legislativna, platna, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SablonaStadiumExternalApi - axios parameter creator
 * @export
 */
export const SablonaStadiumExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of stadium possible to change material to as admin in selected sablona
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSablonaStadiumList: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSablonaStadiumList', 'uuid', uuid)
            const localVarPath = `/sablony-stadia/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SablonaStadiumExternalApi - functional programming interface
 * @export
 */
export const SablonaStadiumExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SablonaStadiumExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * List of stadium possible to change material to as admin in selected sablona
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSablonaStadiumList(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Stadium>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSablonaStadiumList(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SablonaStadiumExternalApi.getSablonaStadiumList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SablonaStadiumExternalApi - factory interface
 * @export
 */
export const SablonaStadiumExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SablonaStadiumExternalApiFp(configuration)
    return {
        /**
         * List of stadium possible to change material to as admin in selected sablona
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSablonaStadiumList(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Stadium>> {
            return localVarFp.getSablonaStadiumList(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SablonaStadiumExternalApi - object-oriented interface
 * @export
 * @class SablonaStadiumExternalApi
 * @extends {BaseAPI}
 */
export class SablonaStadiumExternalApi extends BaseAPI {
    /**
     * List of stadium possible to change material to as admin in selected sablona
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SablonaStadiumExternalApi
     */
    public getSablonaStadiumList(uuid: string, options?: RawAxiosRequestConfig) {
        return SablonaStadiumExternalApiFp(this.configuration).getSablonaStadiumList(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentListExternalApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentListExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get sprievodny dokument list
         * @param {boolean} [platny] valid sprievodny dokument.
         * @param {boolean} [povinny] povinny sprievodny dokument.
         * @param {boolean} [generovany] generovany sprievodny dokument.
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Type of stadiumMaterialu.
         * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentList: async (platny?: boolean, povinny?: boolean, generovany?: boolean, stadiumMaterialu?: StadiumMaterialuEnum, typMaterialuUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sprievodne-dokumenty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platny !== undefined) {
                localVarQueryParameter['platny'] = platny;
            }

            if (povinny !== undefined) {
                localVarQueryParameter['povinny'] = povinny;
            }

            if (generovany !== undefined) {
                localVarQueryParameter['generovany'] = generovany;
            }

            if (stadiumMaterialu !== undefined) {
                localVarQueryParameter['stadiumMaterialu'] = stadiumMaterialu;
            }

            if (typMaterialuUuid !== undefined) {
                localVarQueryParameter['typMaterialuUuid'] = typMaterialuUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentListExternalApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentListExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentListExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get sprievodny dokument list
         * @param {boolean} [platny] valid sprievodny dokument.
         * @param {boolean} [povinny] povinny sprievodny dokument.
         * @param {boolean} [generovany] generovany sprievodny dokument.
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Type of stadiumMaterialu.
         * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSprievodnyDokumentList(platny?: boolean, povinny?: boolean, generovany?: boolean, stadiumMaterialu?: StadiumMaterialuEnum, typMaterialuUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CiselnikPolozka>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSprievodnyDokumentList(platny, povinny, generovany, stadiumMaterialu, typMaterialuUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentListExternalApi.getSprievodnyDokumentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentListExternalApi - factory interface
 * @export
 */
export const SprievodnyDokumentListExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentListExternalApiFp(configuration)
    return {
        /**
         * Get sprievodny dokument list
         * @param {boolean} [platny] valid sprievodny dokument.
         * @param {boolean} [povinny] povinny sprievodny dokument.
         * @param {boolean} [generovany] generovany sprievodny dokument.
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Type of stadiumMaterialu.
         * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentList(platny?: boolean, povinny?: boolean, generovany?: boolean, stadiumMaterialu?: StadiumMaterialuEnum, typMaterialuUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CiselnikPolozka>> {
            return localVarFp.getSprievodnyDokumentList(platny, povinny, generovany, stadiumMaterialu, typMaterialuUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentListExternalApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentListExternalApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentListExternalApi extends BaseAPI {
    /**
     * Get sprievodny dokument list
     * @param {boolean} [platny] valid sprievodny dokument.
     * @param {boolean} [povinny] povinny sprievodny dokument.
     * @param {boolean} [generovany] generovany sprievodny dokument.
     * @param {StadiumMaterialuEnum} [stadiumMaterialu] Type of stadiumMaterialu.
     * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentListExternalApi
     */
    public getSprievodnyDokumentList(platny?: boolean, povinny?: boolean, generovany?: boolean, stadiumMaterialu?: StadiumMaterialuEnum, typMaterialuUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentListExternalApiFp(this.configuration).getSprievodnyDokumentList(platny, povinny, generovany, stadiumMaterialu, typMaterialuUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SviatokListExternalApi - axios parameter creator
 * @export
 */
export const SviatokListExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Slovakia public sviatky.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSviatokList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sviatky`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SviatokListExternalApi - functional programming interface
 * @export
 */
export const SviatokListExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SviatokListExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Slovakia public sviatky.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSviatokList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sviatok>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSviatokList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SviatokListExternalApi.getSviatokList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SviatokListExternalApi - factory interface
 * @export
 */
export const SviatokListExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SviatokListExternalApiFp(configuration)
    return {
        /**
         * Slovakia public sviatky.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSviatokList(options?: RawAxiosRequestConfig): AxiosPromise<Array<Sviatok>> {
            return localVarFp.getSviatokList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SviatokListExternalApi - object-oriented interface
 * @export
 * @class SviatokListExternalApi
 * @extends {BaseAPI}
 */
export class SviatokListExternalApi extends BaseAPI {
    /**
     * Slovakia public sviatky.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SviatokListExternalApi
     */
    public getSviatokList(options?: RawAxiosRequestConfig) {
        return SviatokListExternalApiFp(this.configuration).getSviatokList(options).then((request) => request(this.axios, this.basePath));
    }
}



